import React, { useState } from 'react';
import { SEARCH_WIDGET_OMNITURE } from '../../../../../constants/filterConstants';
import { getAllUrlParams } from '../../../../../helpers/utils';
import OmnitureUtils from '../../../../../../common/utils/Omniture/OmnitureUtils';

const SearchWidget = props => {
  const queryParams = getAllUrlParams();
  const [searchText, setSearchText] = useState(queryParams?.searchText ?? '');
  const { handleFilterChange } = props;

  const handleChange = e => {
    setSearchText(e.target.value);
    if (e.target.value === '') {
      handleFilterChange({ urlParam: 'searchText', values: [''] });
    }
  };

  const keyPress = e => {
    if (e.keyCode == 13) {
      OmnitureUtils.trackClickEvent({
        prop54: SEARCH_WIDGET_OMNITURE,
      });
      handleFilterChange({ urlParam: 'searchText', values: [e.target.value] });
    }
  };

  const searchPackagesByText = () => {
    if (searchText !== '') {
      OmnitureUtils.trackClickEvent({
        prop54: SEARCH_WIDGET_OMNITURE,
      });
      handleFilterChange({ urlParam: 'searchText', values: [searchText] });
    }
  };

  const omnitureEventHandler = () => {
    OmnitureUtils.trackClickEvent({
      prop54: SEARCH_WIDGET_OMNITURE,
    });
  };

  return (
    <>
      <div className="filtersOuter">
        <div className="filterHeadouter">
          <span className="filtersHead">Search This Page:</span>
        </div>
        <div className="searchSection innerListSection">
          <input
            className="searchInput"
            value={searchText}
            type="text"
            onKeyDown={keyPress}
            onChange={handleChange}
            placeholder="Search by city/ activity"
            onFocus={omnitureEventHandler}
          />
          <span className="icon mmt-search" onClick={searchPackagesByText} />
        </div>
      </div>
    </>
  );
};

export default SearchWidget;
